const login = {
  subtitleTop: 'Injection Molding Monitoring System',
  systemTitle: 'Hệ thống điều khiển ép phun tích hợp',
  adminLogin: 'Đăng nhập quản trị viên',
  email: 'Email',
  password: 'Mật khẩu',
  rememberMe: 'Ghi nhớ đăng nhập',
  submit: 'Đăng nhập',
  submitting: 'Đang đăng nhập...',
  forgotPassword: 'Quên mật khẩu?',
  forgotPasswordAlert: 'Vui lòng liên hệ quản trị viên để khôi phục mật khẩu.\n\nEmail quản trị viên: skm@seoro.ai.kr',
  contactAdminAlert: 'Vui lòng liên hệ quản trị viên để tạo tài khoản.\n\nEmail quản trị viên: skm@seoro.ai.kr',
  noAccount: 'Chưa có tài khoản?',
  contactAdmin: 'Liên hệ quản trị viên',
  loginFailed: 'Đăng nhập thất bại',
  serverError: 'Không thể kết nối đến máy chủ',
};

export default login;
